import React, { useRef, memo } from 'react'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import styles from './depositBadge.module.sass'

function DepositBadge() {
  const depositRef = useRef()

  const scrollToTop = () => {
    if (window.scrollTo) {
      window.scrollTo({ 'behavior': 'smooth', 'top': 0 })
    }
  }

  useScrollPosition(({ currPos }) => {
    depositRef.current.style.top = `${window.innerHeight * 0.6 - currPos.y}px`
    depositRef.current.style.transition = 'top 0.5s ease-out'
  }, [])

  return (
    <div className={styles.root}>
      <div className={styles.depositIcon} ref={depositRef}>
        <Link to="/deposit">
          <div className={styles.btn} />
          <div className={clsx(styles.shine, styles.shine01)} />
          <div className={clsx(styles.shine, styles.shine02)} />
          <div className={clsx(styles.shine, styles.shine03)} />
          <div className={styles.led} />
        </Link>
        <div
          className={styles.topBtn}
          aria-hidden="true"
          type="button"
          onClick={scrollToTop}
        />
      </div>
    </div>

  )
}

export default memo(DepositBadge)
